import { Helmet } from "react-helmet-async";

interface SEOHeadProps {
  title: string;
  description: string;
  canonical?: string;
  type?: "website" | "article" | "product";
  image?: string;
  imageAlt?: string;
  noindex?: boolean;
  keywords?: string;
  priceLabel?: string;
  priceValue?: string;
}

const SEOHead = ({
  title,
  description,
  canonical,
  type = "website",
  image = "https://webhostbuybd.com/og-image.jpg",
  imageAlt = "Web Host Buy BD - Best BDIX Hosting Provider in Bangladesh",
  noindex = false,
  keywords,
  priceLabel,
  priceValue,
}: SEOHeadProps) => {
  const siteUrl = "https://webhostbuybd.com";
  const fullTitle = `${title} | Web Host Buy BD`;
  // Ensure consistent canonical: home = siteUrl + "/" , others = no trailing slash
  const canonicalUrl = canonical === "/" 
    ? `${siteUrl}/` 
    : canonical 
      ? `${siteUrl}${canonical}`.replace(/\/+$/, "") 
      : `${siteUrl}/`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && (
        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />
      )}
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content="Web Host Buy BD" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:secure_url" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={imageAlt} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:site_name" content="Web Host Buy BD" />
      <meta property="og:locale" content="en_BD" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={imageAlt} />
      <meta name="twitter:site" content="@WebHostBuyBD" />
      <meta name="twitter:creator" content="@WebHostBuyBD" />
      {priceLabel && (
        <meta name="twitter:label1" content={priceLabel} />
      )}
      {priceValue && (
        <meta name="twitter:data1" content={priceValue} />
      )}
    </Helmet>
  );
};

export default SEOHead;
